import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-criminal-law',
  templateUrl: './criminal-law.component.html',
  styleUrls: ['./criminal-law.component.css']
})
export class CriminalLawComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
